const taskKeys = {
  taskList: (params) => ["taskList", params],
  singleTask: (taskId, instanceStartDate) =>
    ["singleTask", taskId, instanceStartDate].filter(Boolean),
  history: (taskId) => [...taskKeys.singleTask(taskId), "history"],
};

export default taskKeys;
